import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";

class RecoverpasswordsuccessController {
  constructor($http, $localStorage, $state, AuthService, $timeout, EnvService) {
    this.name = "recoverpasswordsuccess";
    $localStorage.activeStateName = "events";

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$timeout = $timeout;
    this.$env = EnvService;

    this.recover_email = this.$auth.getRecoverEmail();
    this.message = "A recovery link has been sent to " + this.recover_email;
    this.remain_loading_count = 0;

    // $('body').removeClass().addClass('signup-bg');
  }

  resendForgotEmail() {
    this.$state.go("recoverpassword");
  }

  submitRecoverLink() {
    var _this = this;

    var req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "register/forgotPassword?format=json&username=" + this.recover_email,
      data: {},
    };

    _this.remain_loading_count++;
    this.$http(req).then(
      function (data) {
        console.log(data);
        _this.remain_loading_count--;
        _this.result.status = data.data.status;
        _this.result.message = data.data.message;
        if (data.data.status == "error") {
          _this.message = "A recovery link has not been sent to " + _this.recover_email;
          return;
        }
        _this.message = "A recovery link has been sent to " + _this.recover_email;
      },
      function (data) {
        console.log(data);
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }
}

RecoverpasswordsuccessController.$inject = ["$http", "$localStorage", "$state", "auth", "$timeout", "env"];

export default RecoverpasswordsuccessController;



// WEBPACK FOOTER //
// ./client/app/components/recoverpasswordsuccess/recoverpasswordsuccess.controller.js